module.exports = __webpack_public_path__ + "static/media/crowdbg.6411c4d4.png";